import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { useCallback } from 'react';
import { devPortalOrgHubApiRef } from '../api';
import useAsync from 'react-use/lib/useAsync';

export const useUsers = () => {
  const api = useApi(devPortalOrgHubApiRef);
  const errorApi = useApi(errorApiRef);

  const getUsers = useCallback(async () => {
    try {
      return await api.fetchUsers();
    } catch (error) {
      if (error instanceof Error) {
        errorApi.post(error);
      }
      return Promise.reject(error);
    }
  }, [api, errorApi]);

  const { loading, value, error } = useAsync(() => getUsers(), [getUsers]);

  return { value, loading, error };
};
